export const trainListEn = {
    placeholder:"Please enter service keyword",
    feiyong:"cost",
    spxx:'Commodity information',
    dingdh:'Order number',
    xdsj:'Order time',
    pxfwlx:'Type of training service',
    jcrz:'Testing and certification',
    ddze:'Total orders',
    khzh:'Customer account number',
    tcxx: 'The package information',
    ddzt:'Order status',
    fwmc:'Service name',
    dangjia:'Unit Price',
    keshi:'Class hour',
    heji:'Total',
    xfjyfw:'Consumer goods inspection service',
    zfxx:'Payment information',
    fkfs:'Payment method',
    fksj:'Payment time',
    fwje:'Service amount',
    yzfje:'Amount payable',
    youhuiq:'Coupon',
    ddyh:'Order discount',
    fhddlb:'Return to training order list',
    ddqr:'acknowledgement of order',
    ddzf:'Order payment',
    ddwc:'Order fulfillment'
}


// WEBPACK FOOTER //
// ./src/lang/home/trainList/indexEn.js